import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {createTheme, ThemeProvider} from '@mui/material';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import Raleway from './assets/fonts/Raleway-VariableFont_wght.ttf';

const root = ReactDOM.createRoot(document.getElementById('root'));

const theme = createTheme({
    palette: {
        primary: {
            main: '#000000',
        },
        secondary: {
            main: '#00A3FF',
        },
        divider: 'rgba(0, 0, 0, 0.2)',
        background: {
            secondary: 'rgba(0, 0, 0, 0.04)',
        },
    },
    typography: {
        fontFamily: 'PrimaryFont',
        h5: {
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
        },
        h6: {
            fontSize: '1rem', // Adjusted to be slightly smaller than default h6 but larger than body1
            fontWeight: 500,
        },
        body1: {
            fontSize: '0.875rem', // Updated to match the new font size
            fontWeight: 450,
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face {
                  font-family: 'Raleway';
                  font-style: normal;
                  font-display: swap;
                  font-weight: 400;
                  src: local('Raleway'), local('Raleway-Regular'), url(${Raleway}) format('ttf');
                }
            `,
        },
        MuiListItemText: { // Add this section
            styleOverrides: {
                primary: {},
            },
        },
        MuiOutlinedInput: { // Add this section
            styleOverrides: {
                root: { // styles applied to the root variant
                    borderRadius: '0px', // Set border radius to 0px
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {},
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    fontSize: '0.875rem', // Set the font size to match body1
                },
            },
        },
    },
});

const queryClient = new QueryClient();

root.render(
  <BrowserRouter future={{v7_startTransition: true, v7_relativeSplatPath: true}}>
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <App/>
      </QueryClientProvider>
    </ThemeProvider>
  </BrowserRouter>,
);
